import { useEffect } from 'react'
import { useOnboardSensors } from '@/core/hooks-and-services/onboardedSensorsService'
import { addGlobalErrorMessage, addSnackBarMessage } from '@/core/store/globalStore'
import { OnboardPayload } from '@/core/models/types'

export const useTriggerOnboarding = () => {
    const { triggerOnboardSensors, isSuccess, isError, isQueuedOffline, errorMessages, isLoading, successMessage } =
        useOnboardSensors()

    useEffect(() => {
        if (isSuccess) {
            addSnackBarMessage(successMessage)
        }
        if (isError) {
            errorMessages.map((x) => addGlobalErrorMessage(x))
        }
    }, [isSuccess, isError, successMessage])

    /**
     * Calls the onboarding API and handles notifications.
     */
    const onboard = async (data: OnboardPayload) => {
        try {
            await triggerOnboardSensors(data.plant ?? '', data)
        } catch (err) {
            console.error('Onboarding failed', err)
        }
    }

    return {
        onboard,
        isLoading,
        isSuccess,
        isError,
        isQueuedOffline,
    }
}
